import {intersection} from './array';

const objHasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Filters keys from the *this* object.
 * @this object
 * @param {array|function} filter
 * @return {object} Object containing only the filtered keys.
 * @example
 * import {filterKeys} from 'js-utils';
 * {a: 1, b: 2, c: 3}::filterKeys(['b']); // {b: 2}
 * {a: 1, b: 2, c: 3}::filterKeys(k => k === 'b'); // {b: 2}
 */
export function filterKeys(filter) {
	let keys = Object.keys(this);
	if (Array.isArray(filter)) {
		keys = keys::intersection(filter);
	} else if (typeof filter === 'function') {
		keys = keys.filter(filter);
	} else {
		throw new TypeError(`Unsupported filter type "${typeof filter}"`);
	}

	const ret = Object.create(null);
	keys.forEach(key => {
		ret[key] = this[key];
	});
	return ret;
}

/**
 * Checks if *this* is an object or a function.
 * @this object|function
 * @return {boolean} true if *this* is an object or a Function
 * @example
 * import {isObject} from 'js-utils';
 * {}::isObject(); // true
 * 42::isObject(); // false
 */
export function isObject() {
	if (this === null) {
		return false;
	}
	const type = typeof this;
	return type === 'object' || type === 'function';
}

/**
 * deep freeze an object
 * @this object
 * @return {object} *this*
 * @throws {TypeError} if *this* is not an object
 * @example
 * import {deepFreeze} from 'js-utils';
 * const obj = {a: {b: 42}}::deepFreeze();
 * obj.a.b = 43; // error
 */
export function deepFreeze() {
	if (!this::isObject()) {
		throw new TypeError(`this "${this}" is not an object`);
	}

	Object.freeze(this);

	for (const key in this) {
		if (!this::objHasOwnProperty(key)) {
			continue;
		}

		const prop = this[key];
		if (prop::isObject() && !Object.isFrozen(prop)) {
			prop::deepFreeze();
		}
	}

	return this;
}
